<template>
  <el-container id="glWx">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background: #F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px"> {{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding-left:15px">
        <p style="margin-top:10px">微信小程序URL：</p>
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <el-input
            v-model="edi_url"
            placeholder="输入URL"
            style="width:18vw;"
            prefix-icon="el-icon-search"
            clearable>
          </el-input>
          <el-button type="primary" style="margin-left:10px" @click="keepInfo">保存</el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

export default {
  name:"glWx",
  components:{ /*引入组件*/

  },
  data(){
    return {
      h_text:"小程序配置",
      li_h_text:[
        {"text":"管理配置","colour":"#B7B7B7","pages":""}
      ],
      edi_url:""
    };
  },
  methods:{ /*方法存放*/
    getURL(){
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getProjectInfo,params,headers).then(res => {
        console.log("getURL",res.data.data);
        this.edi_url = res.data.data['wxCodeUrl'];
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取信息失败");
        }
      });
    },
    keepInfo(){
      const params = {
        "id":localStorage.getItem("projectId"),
        "wxCodeUrl":this.edi_url
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateProjectWxCodeUrl,params,headers).then(res => {
        console.log("keepInfo",res.data.data);
        this.$message.success("保存成功");
        this.getURL();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error(error);
        } else {
          this.$message.error("保存信息失败");
        }
      });
    }
  },
  mounted(){ /*页面加载时调用*/
    this.getURL();
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>

#glWx {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glWx.vue